import React, { FC } from "react";
import styles from './toggle-switch.module.scss';

interface ToggleSwitchProps {
  label?: string;
  isChecked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

const ToggleSwitch: FC<ToggleSwitchProps> = ({ label, isChecked, onChange, disabled = false, className = '', id }) => {
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.checked);
    }
  };

  const sliderClass = isChecked ? `${styles.slider} ${styles.active}` : `${styles.slider} ${styles.inactive}`;

  return (
    <div className={`${styles.toggleSwitch} ${className}`}>
      <label className={styles.switch}>
        <input
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={handleToggle}
          disabled={disabled}
        />
        <span className={sliderClass}></span>
      </label>
      {label && <span className={styles.labelText}>{label}</span>}
    </div>
  );
}

export default ToggleSwitch;
